<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
import uiStore from '../utils/UIStore';
import Link from './Link.svelte';

let uiTexts;
uiStore.textStore.subscribe((store) => {
  uiTexts = store.texts;
});

import { isAuthenticated } from '../utils/KeycloakService';
import Login from './Login.svelte';

let y;
export let currentTab = 2;
export let callback = () => console.log(uiTexts.navbar.noCallbac);

function handleLoginSuccess() {
  console.log('Login successful');
}

function handleLoginError(error) {
  console.error('Login error:', error);
}
</script>

<svelte:window bind:scrollY={y} />

<nav
  class={(currentTab = !4
    ? "navbar"
    : y > 50
      ? "navbar navbar_shadow"
      : "navbar")}
>
  <div class="row" style="height:100%">
    <img class="logo" src="/logos/header-left-logo.svg" alt="{uiTexts.navbar.logoAlt}" />

    <div class="title" on:click={() => callback()}>
      <Link to="/">
        <h1>F13</h1>
        <span class="semibold">{uiTexts.navbar.subtitle}</span>
      </Link>
    </div>
  </div>

  <slot name="tabs" />

  <div class="menu-container">
    <slot name="menu" />
    <div class="login-wrapper">
      <Login onLoginSuccess={handleLoginSuccess} onLoginError={handleLoginError} />
    </div>
  </div>

  <img
    class="logo navbar-right"
    src="/logos/header-right-logo.png"
    alt="{uiTexts.navbar.logoAlt}"
  />
</nav>

<style>
  .aa_mobile {
    display: none;
    padding-top: 8px;
    padding-bottom: 10px;
    margin-right: 10px;
  }
  nav {
    top: 0;
    width: 100%;
    display: flex;
    height: 90px;
    overflow: hidden;
    position: fixed;
    z-index: 100;
    box-shadow: 0 0 0px rgba(0, 0, 0, 0.096);
    border-bottom: 0px solid black;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
  }

  .navbar {
    /*optional es hintergrund bild:width:
    background: url("/logos/banner.png");*/
    background-size: 150%;
    background-repeat: no-repeat;
    background-position: center;
    background-color: var(--bg-color);
  }

  @media screen and (max-width: 1500px) {
    .navbar {
      background-size: 200%;
    }
  }

  @media screen and (max-width: 1208px) {
    .navbar {
      background-size: 250%;
    }
    .navbar-right {
      display: none;
    }
  }

  @media screen and (max-width: 905px) {
    .navbar {
      background: none;
      background-color: var(--main-color);
    }

    .aa_mobile,
    .il {
      height: 60px;
      padding-left: 0px;
      padding-right: 0px;
      padding-bottom: 0px;
    }

    .aa_mobile {
      padding-bottom: 8px;
      margin-right: 0;
    }
  }

  @media screen and (max-width: 700px) {
    h1 {
      font-size: 1rem;
    }
  }

  .navbar_shadow {
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.096);
  }

  .navbar_nocolor {
    background-color: transparent;
  }

  .menu-container {
    display: flex;
    align-items: center;
    position: absolute;
    right: 90px;
    top: 50%;
    transform: translateY(-50%);
    @media screen and (max-width: 1208px) {
      right: 20px;
    }
  }

  .login-wrapper {
    display: flex;
    align-items: center;
    margin-left: 20px;
  }

  h1 {
    letter-spacing: 1px;
  }

  img {
    height: 70px;
    padding-left: 0px;
    padding-right: 0px;
    padding-bottom: 8px;
  }
  .logo {
    height: 100%;
    box-sizing: border-box;
    padding: 0;
  }
  .aa {
    padding-top: 0px;
    padding-bottom: 8px;
  }

  .row {
    align-items: center;
  }

  .title {
    padding-left: 15px;
  }
  .navbar_tabs {
    margin-top: 20px;
  }

  @media screen and (max-width: 1500px) {
    .navbar_tabs {
      margin-right: 0vw;
      width: 90vw;
      gap: 10px;
      justify-content: center;
    }
  }

  @media screen and (max-width: 1208px) {
    .navbar_tabs {
      display: none;
    }
    .mobile_menu {
      display: block;
    }
    .il,
    .aa {
      display: none;
    }
    .aa_mobile {
      display: flex;
    }
    .login-wrapper {
      display: none; /* Hide desktop login when mobile menu is active */
    }
  }
</style>
